export const uploadsSelector = state => state.communityUploads.get('uploads');
